const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 33 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M26.149,4.768c1.641,0.055 2.664,2.35 1.446,3.6l-8.121,8.12c2.718,2.718 5.471,5.403 8.155,8.155c0.911,0.983 0.633,2.743 -0.593,3.347c-0.956,0.471 -2.424,-0.399 -2.424,-0.399l-8.122,-8.12c-2.718,2.718 -5.404,5.47 -8.156,8.154c-0.931,0.864 -2.606,0.675 -3.272,-0.455c-0.575,-0.974 0.324,-2.562 0.324,-2.562l8.121,-8.12c-2.718,-2.718 -5.471,-5.403 -8.155,-8.155c-0.864,-0.932 -0.675,-2.607 0.455,-3.273c0.975,-0.574 2.562,0.325 2.562,0.325l8.121,8.12c2.719,-2.718 5.405,-5.47 8.157,-8.154c0.412,-0.383 0.836,-0.589 1.502,-0.583Z",
    style: {
      fill: "#bd392c"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.72261190d4485cbfbbe8fb4a2e5cd82a.svg";
export { ForwardRef as ReactComponent };